import React, { forwardRef, ReactNode } from 'react';
import classNames from 'classnames';

import css from './style.module.scss';

interface IProps {
  children: ReactNode;
  type?: 'grid';
  direction?: 'row';
  isWrapped?: boolean;
  columns?: '3';
  gap?: '4' | '8' | '12' | '16' | '20' | '24' | '32';
  indents?: '16' | '0-0-24';
  overflow?: 'auto';
  height?: 'full';
  width?: 'full';
  style?: 'circle';
  justify?: 'space-between';
  className?: string;
  align?: 'start' | 'center';
  isResponsive?: boolean;
  maxItemWidth?: 'full';
  withSubChildren?: boolean;
}

const List = forwardRef<HTMLUListElement, IProps>(
  (
    {
      children,
      type,
      direction,
      isWrapped,
      columns,
      gap,
      indents,
      height,
      width,
      overflow,
      style,
      justify,
      className,
      align,
      isResponsive,
      maxItemWidth,
      withSubChildren,
    },
    ref,
  ) => {
    return (
      <ul
        ref={ref}
        className={classNames(
          css.list,
          {
            [css[`list_type_${type}`]]: type,
            [css[`list_direction_${direction}`]]: direction,
            [css[`list_columns_${columns}`]]: columns,
            [css[`list_gap_${gap}`]]: gap,
            [css[`list_indents_${indents}`]]: indents,
            [css[`list_height_${height}`]]: height,
            [css[`list_width_${width}`]]: width,
            [css[`list_overflow_${overflow}`]]: overflow,
            [css[`list_style_${style}`]]: style,
            [css[`list_justify_${justify}`]]: justify,
            [css[`list_align_${align}`]]: align,
            [css.isResponsive]: isResponsive,
            [css.isWrapped]: isWrapped,
          },
          className,
        )}
      >
        {Array.isArray(children) ? (
          (withSubChildren ? children.flat() : children).map((item, i) => {
            if (!item) {
              return null;
            }

            return (
              <li
                className={classNames(css.list__item, {
                  [css[`list__item_maxWidth_${maxItemWidth}`]]: maxItemWidth,
                })}
                key={`item-${i}`}
              >
                {item}
              </li>
            );
          })
        ) : (
          <li
            className={classNames(css.list__item, {
              [css[`list__item_maxWidth_${maxItemWidth}`]]: maxItemWidth,
            })}
          >
            {children}
          </li>
        )}
      </ul>
    );
  },
);

export default List;
